import { Button } from "flowbite-react";
import { ArrowLeft, House, SignOut } from "@phosphor-icons/react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks";
import AnimatedModal from "../components/AnimatedModal";

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, permittedRoutes, logout } = useAuth();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleLogout = () => {
    setShowLogoutModal(false);
    logout();
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-primary-600">
          {t("notFound.title")}
        </h1>
        <h2 className="text-3xl font-bold text-gray-900 mt-4 mb-6">
          {t("notFound.heading")}
        </h2>
        <p className="text-gray-600 mb-8 max-w-md mx-auto">
          {t("notFound.description")}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            color="primary"
            onClick={() =>
              navigate(user ? (permittedRoutes[0] || {}).path || "/" : "/")
            }
            className="flex items-center"
          >
            <House className="mr-2 h-5 w-5" />
            {t("notFound.goHome")}
          </Button>
          <Button
            color="light"
            onClick={() => navigate(-1)}
            className="flex items-center"
          >
            <ArrowLeft className="mr-2 h-5 w-5" />
            {t("notFound.goBack")}
          </Button>
          <Button
            color="failure"
            onClick={() => setShowLogoutModal(true)}
            className="flex items-center"
          >
            <SignOut className="mr-2 h-5 w-5" />
            {t("common.logout")}
          </Button>
          <AnimatedModal
            isConfirmation
            show={showLogoutModal}
            onClose={() => setShowLogoutModal(false)}
            onConfirm={handleLogout}
            title={t("common.confirm_logout")}
            children={
              <div className="text-gray-700 text-center">
                {t("common.logout_confirmation_message")}
              </div>
            }
            confirmText={t("common.logout")}
            confirmButtonColor="red"
          />
        </div>
      </div>
    </div>
  );
};

export default NotFound;
